module.exports = __webpack_public_path__ + "static/media/meritize-wordmark-winter.324fd376.svg";